import React from 'react'
import styled from 'styled-components'

const Button = ({ text }) => {
    return (
        <Btn>
            <h1>... {text}</h1>
        </Btn>
    )
}

const Btn = styled.div`
    margin-top: 2rem;
    background: white;
    border: 1px solid lightgray;
    padding: 2rem 4rem;
    color: gray;
    background: linear-gradient(to left, #fff 50%, #191919 50%) right;
    background-size: 200%;
    transition: .5s ease-out;

    &:hover {
        background-position: left;
        color: #fff;
        cursor: pointer;
    }
`;

export default Button
